<script>
export default {
  name: 'MondialLogo',
}
</script>
<style lang="scss" scoped>
    #mondialWrapper {
        display:inline-flex;
        width: auto;
        margin: 0 auto;

        border-width: 3px;
        border-style: solid;
        border-image: linear-gradient(
                        to bottom,
                        rgb(200, 182, 147) 0%,
                        rgb(255, 243, 216) 100%
        ) 1 100%;

        span {
            font-weight: bold;
        }
    }
</style>
<template>
    <div id="mondialContainer" class="d-flex align-items-center justify-content-center">
        <div id="mondialWrapper" class="justify-content-center align-items-center pl-4 align-self-center">
            <span class="mr-1">DOSTĘP DO TREŚCI ZAPEWNIA:</span>
            <a href="https://mondial-assistance.pl/">
                <img src="/img/mondial-logo.png" alt="Mondial Logo" />
            </a>
        </div>
    </div>
</template>
